<div class="modal-header">
	<p>{{titre |translate:messageParams}}</p>
</div>
<div class="modal-body">
	<alert nom="modalConfirmation"></alert>
	<p>{{message |translate:messageParams}}</p>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-primary" (click)="validate()">{{messageConfirmer | translate}}</button>
	<button type="button" class="btn btn-link" (click)="activeModal.close()">{{messageAnnuler | translate}}</button>
</div>
